import React from 'react';
import {
  Box,
  Chip,
  Button,
  Typography,
  useTheme
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearAllIcon from '@mui/icons-material/ClearAll';

const FilterChips = ({ filters, onClearAll }) => {
  const theme = useTheme();
  
  // Get category color
  const getCategoryColor = (category) => {
    switch (category) {
      case 'physical':
        return theme.palette.primary.main;
      case 'academic':
        return theme.palette.success.main;
      case 'track':
        return theme.palette.info.main;
      case 'strength':
        return theme.palette.warning.main;
      case 'sportSpecific':
        return theme.palette.secondary.main;
      case 'location':
        return theme.palette.error.main;
      default:
        return theme.palette.primary.main;
    }
  };
  
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
      {filters.length > 0 ? (
        <>
          <FilterListIcon color="action" sx={{ mr: 1 }} />
          <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
            Active Filters:
          </Typography>
          
          {filters.map((filter) => (
            <Chip
              key={filter.id}
              label={filter.label}
              onDelete={filter.onDelete}
              sx={{ 
                borderColor: getCategoryColor(filter.category),
                borderWidth: 1,
                borderStyle: 'solid',
                '& .MuiChip-deleteIcon': {
                  color: getCategoryColor(filter.category),
                  '&:hover': {
                    color: theme.palette.error.main
                  }
                }
              }}
            />
          ))}
          
          <Button
            variant="text"
            color="error"
            size="small"
            startIcon={<ClearAllIcon />}
            onClick={onClearAll}
            sx={{ ml: 1 }}
          >
            Clear All
          </Button>
        </>
      ) : (
        <Typography variant="body2" color="text.secondary">
          No filters applied. Use the filter panel to refine your search.
        </Typography>
      )}
    </Box>
  );
};

export default FilterChips;
